import { ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { LevelProgressService } from '../../../shared/level-progress/level-progress.service';
import { PropertyLevelProgressDto } from '../../../shared/types/PropertyLevelProgressDto';
import { StudyBundleCourseDto } from '../../../shared/types/StudyBundleCourseDto';
import { GamificationActivityType } from '../../../shared/types/gamification-activity-type';
import { LessonCarouselService } from '../../lesson-carousel/lesson-carousel.service';
import MiniLessonsCalculations from '../mini-lessons-calculations';

@Component({
  selector: 'lp2-mini-lesson-section',
  templateUrl: './mini-lesson-section.component.html',
  styleUrls: ['./mini-lesson-section.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MiniLessonSectionComponent implements OnInit, OnDestroy {
  @Input()
  set activityPoints(value: Map<GamificationActivityType, number>) {
    this.lessonPoints = value ? value.get(GamificationActivityType.COMPLETE_LESSON) : 0;
  }

  lessonPoints: number;
  lessons$ = new BehaviorSubject<StudyBundleCourseDto[]>(undefined);
  allLessonsCompleted: boolean;
  unitLevelProgress$ = new BehaviorSubject<PropertyLevelProgressDto>(undefined);

  destroy = new Subject<boolean>();

  get lessons() {
    return this.lessons$.value;
  }

  get unitLevelProgress() {
    return this.unitLevelProgress$.value;
  }

  constructor(
    private lessonService: LessonCarouselService,
    private levelProgressService: LevelProgressService,
  ) {}

  ngOnInit() {
    this.lessonService.getLessons().subscribe((data: StudyBundleCourseDto[]) => {
      this.allLessonsCompleted = MiniLessonsCalculations.areAllLessonsCompleted(data);
      this.lessons$.next(data);

      // Uncoment the following code to complete all the lessons until Unit 7 assessment (mid-level test)
      // const unit7Id = 168;
      // const unit7AssessmentRule = (lesson) => lesson.unitId !== unit7Id || lesson.type !== LessonType.UNIT_ASSESSMENT;
      // const lessonsToBeCompleted = data.filter((lesson) => unit7AssessmentRule(lesson));
      // lessonsToBeCompleted.forEach((lesson) => {
      //   if (lesson.type === LessonType.UNIT_ASSESSMENT) {
      //     setTimeout(() =>this.lessonService.finishAssessment(lesson.id).pipe(tap(() => window.location.reload())).subscribe())
      //   }
      //   if (lesson.status !== StudyBundleCourseStatusType.COMPLETE) {
      //     console.log('test')
      //     setTimeout(() => this.lessonService.completeLesson(lesson.id).subscribe()) 
      //   }
      // })
    });

    this.levelProgressService.unitLevelProgress$
      .pipe(takeUntil(this.destroy))
      .subscribe((data: PropertyLevelProgressDto) => this.unitLevelProgress$.next(data));
  }

  ngOnDestroy() {
    this.destroy.next(true);
    this.destroy.unsubscribe();
  }
}



// WEBPACK FOOTER //
// ./ts/app/home/mini-lesson-section/mini-lesson-section/mini-lesson-section.component.ts